import React from 'react';

import { Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import { useThemeMode } from '../../providers/ThemeModeProvider';
import { Image } from '../Image/Image';

import themeDarkImg from './theme-dark-icon.svg';
import themeLightImg from './theme-light-icon.svg';

export const ThemeModeToggle = ({ tooltip, teamColor }: { tooltip?: string; teamColor?: boolean }) => {
  const { toggleThemeMode, themeMode } = useThemeMode();

  const icon = () => {
    if (teamColor) {
      return <Image testId="theme-toggle-light-icon" src={themeLightImg} />;
    }
    return themeMode === 'light' ? (
      <Image testId="theme-toggle-dark-icon" src={themeDarkImg} />
    ) : (
      <Image testId="theme-toggle-light-icon" src={themeLightImg} />
    );
  };

  return (
    <Tooltip title={tooltip || ''} arrow>
      <IconButton data-testid="theme-toggle-button" onClick={toggleThemeMode}>
        {icon()}
      </IconButton>
    </Tooltip>
  );
};
